import { fetchCollectionList, fetchProductList, fetchVideoGenerateList } from "../librarySlice";
import "./index.scss";
import Section from "@components/Section";
import type { UserAssetRecord } from "@apis/http/api";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { useEffect } from "react";
import UIVideoCard from "./UIVideoCard";
import UIScriptCard from "./UIScriptCard";
import UIProductCard from "./UIProductCard";
import UIVideoGenerateCard from "./UIVideoGenerateCard";

interface UICardWrapProps {
  onVideoDetailClick?: (record: UserAssetRecord, index: number) => void;
}

const UICardWrap = ({ onVideoDetailClick }: UICardWrapProps) => {
  const { videoGeneratedList, focusType, videoType, cardItems, cardStatus, cardPageSize, cardPageNo } = useAppSelector(
    (state) => state.libraryReducer,
  );

  const dispatch = useAppDispatch();

  const requestCardList = async () => {
    if (focusType === "product") {
      dispatch(fetchProductList());
      return;
    }
    if (focusType === "video") {
      if (videoType === "generated") {
        dispatch(fetchVideoGenerateList({}));
      } else {
        dispatch(fetchCollectionList({ type: 1 }));
      }
      return;
    }
    if (focusType === "script") {
      dispatch(fetchCollectionList({ type: 2 }));
    }
  };

  useEffect(() => {
    requestCardList();
  }, [focusType, videoType, cardPageNo, cardPageSize]);

  return (
    <div>
      <Section
        className="min-h-[300px]"
        status={cardStatus}
        reload={requestCardList}
        // BlankResult={<NoFocus></NoFocus>}
      >
        {focusType === "script" && (
          <div className="grid grid-cols-3 gap-[16px]">
            {cardItems.map((item) => (
              <UIScriptCard key={item.id} record={item}></UIScriptCard>
            ))}
          </div>
        )}
        {focusType === "video" && (
          <div className="grid grid-cols-5 min-[1920px]:grid-cols-6 gap-[16px]">
            {videoType === "generated" &&
              videoGeneratedList.data.map((item, index) => (
                <UIVideoGenerateCard
                  key={item.id}
                  record={item}
                  onDetailClick={(record) => onVideoDetailClick && onVideoDetailClick(record, index)}
                />
              ))}
            {videoType === "saved" && cardItems.map((item) => <UIVideoCard key={item.id} record={item}></UIVideoCard>)}
          </div>
        )}
        {focusType === "product" && (
          <div className="grid grid-cols-5 min-[1920px]:grid-cols-6 gap-[16px]">
            {cardItems.map((item) => (
              <UIProductCard key={item.id} record={item}></UIProductCard>
            ))}
          </div>
        )}
        {/* {["script", "video", "product"].includes(focusType) && (
         <div className="flex justify-end mt-[24px]">
           <Pagination
             current={cardPageNo}
             total={focusCount}
             showSizeChanger={false}
             pageSize={cardPageSize}
             onChange={(pageNo) => dispatch(updateCardPageNo(pageNo))}
           />
         </div>
        } */}
      </Section>
    </div>
  );
};

export { UICardWrap };
